import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=bf785000&"
import script from "./MessagesView.vue?vue&type=script&lang=ts&"
export * from "./MessagesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports